import { StoryblokHeroSubpage } from './StoryblokHeroSubpage'

import { createHeroSubpage } from './__mocks__/heroSubpage'

export { createHeroSubpage }

// Re-export for backward compatibility
export const dummyBlokHeroSubpageStoryblok = createHeroSubpage()

export default StoryblokHeroSubpage
